if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');
			const prefix = window.KT_PREFIX || '';

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector(`.${prefix}remove`);
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);

						// 2) Fire SYNC event so product-card resets to 0
						const variantId = item.dataset.id.split(":")[0];

							document.dispatchEvent(
							new CustomEvent("cart-qty-changed", {
								detail: { variantId, qty: 0 }
							})
						);
					})
				}

				const qty = item.querySelector(`.${prefix}qty`);
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			let alert = null;
			const prefix = window.KT_PREFIX || '';

			this.form.classList.add(`${prefix}processing`);
			if ( this.querySelector(`.${prefix}alert`) ) {
				this.querySelector(`.${prefix}alert`).remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add(`${prefix}alert`, `${prefix}alert--error`);
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
						KROWN.functions.eventDispatcher('krown:cart:error', {
							error: alert.textContent
						});
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
					const event = new Event('cart-updated');
					this.dispatchEvent(event);

					const updatedItem = cartItems.querySelector(`[data-js-cart-item][data-line="${item.dataset.line}"]`);
					if ( updatedItem ) {
						KROWN.functions.eventDispatcher('krown:cart:update', {
							itemKey: updatedItem.dataset.id,
							itemQty: updatedItem.dataset.qty,
							itemVariantId: updatedItem.dataset.variant,
							itemProductId: updatedItem.dataset.productId
						});
					}

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add(`${prefix}alert`, `${prefix}alert--error`);
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove(`${prefix}processing`);
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this._prefix = window.KT_PREFIX || '';
			this.querySelector(`.${this._prefix}qty-minus`).addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector(`.${this._prefix}qty-plus`).addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				console.log('-----------');
				console.log(this.querySelector(`.${this._prefix}qty`).value);
				console.log('-----------');
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector(`.${this._prefix}qty`).value));

				// ⭐ OUR CUSTOM SYNC EVENT (SAFE)
				document.dispatchEvent(
					new CustomEvent("cart-drawer-qty-change", {
						detail: {
							variantId: this.closest('[data-js-cart-item]').dataset.id.split(":")[0],   // Variant ID
							qty: this.querySelector('.qty').value
						}
					})
				);
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = (openDrawer = true) => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') && openDrawer === true ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}

if ( ! customElements.get('cart-note') ) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						});
		  		}, 150)
				);
      }
    }
  );
}

if ( ! customElements.get('cart-discounts' ) ) {
	customElements.define(
		'cart-discounts',
		class CartDiscounts extends HTMLElement {

			constructor() {

				super();

				const button = this.querySelector('[data-js-discount-submit]');
				this.input = this.querySelector('[data-js-discount-input]');
				this.cartSubtotal = document.getElementById('AjaxCartSubtotal');
				this.cartDiscountError = this.querySelector('[data-js-discount-error]');
				this.discountCodes = document.querySelector('[data-js-discount-codes]');
				this._prefix = window.KT_PREFIX || '';
				this.loadDiscountButtons();

				button.addEventListener('click', (e) => {
					e.preventDefault();
					if ( this.input.value.length > 0 ) {

						this.cartSubtotal.classList.add(`${this._prefix}processing`);
						if (this.discountCodes) {
							this.discountCodes.classList.add(`${this._prefix}processing`);
						}

						const existingDiscounts = Array.from(this.querySelectorAll('[data-js-discount]')).map(elm => elm.dataset.jsDiscount);
						
						const allDiscounts = [...existingDiscounts, this.input.value];
						const discountString = allDiscounts.join(',');
						const body = JSON.stringify({ discount: discountString });

						fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						})
							.then(response => response.json())
							.then(response => {
								const discountCodes = response.discount_codes;
								const inputValue = this.input.value;
								const matchingCode = discountCodes.find(code => 
									code.code === inputValue
								);

								if (matchingCode) {
									if (matchingCode.applicable) {
										this.handleSuccess();
									} else {
										this.handleError();
									}
								} else {
									this.handleError();
								}
							})
							.catch(error => {
								this.handleError();
								console.log(`Error: ${error}`);
							})

					}

				});

			}

			handleSuccess(){
				fetch('?section_id=helper-cart')
					.then(response => response.text())
					.then(text => {
						const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
						const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
						this.cartSubtotal.innerHTML = cartSubtotalInnerHTML;
						this.cartSubtotal.classList.remove(`${this._prefix}processing`);
						this.cartDiscountError.innerHTML = '';
						if ( sectionInnerHTML.querySelector('[data-js-discount-codes]') ) {
							this.discountCodes.innerHTML = sectionInnerHTML.querySelector('[data-js-discount-codes]').innerHTML;
							this.discountCodes.classList.remove(`${this._prefix}processing`);
							this.loadDiscountButtons();
						}
						this.input.value = '';
					})
			}

			loadDiscountButtons(){
				this.querySelectorAll('[data-js-discount]').forEach(elm=>{
					if ( ! elm.classList.contains(`${this._prefix}enabled`) ) {
						elm.classList.add(`${this._prefix}enabled`);
						elm.addEventListener('click', (e)=>{
							e.preventDefault();
							this.cartSubtotal.classList.add(`${this._prefix}processing`);
							if (this.discountCodes) {
								this.discountCodes.classList.add(`${this._prefix}processing`);
							}
							const discountToRemove = elm.dataset.jsDiscount;
							
							const allDiscountElements = this.querySelectorAll('[data-js-discount]');
							const allDiscounts = Array.from(allDiscountElements).map(el => el.dataset.jsDiscount);
							
							const remainingDiscounts = allDiscounts.filter(discount => discount !== discountToRemove);
							
							const body = JSON.stringify({ 
								discount: remainingDiscounts.join(',') 
							});
							
							fetch(`${KROWN.settings.routes.cart_update_url}`, { 
								method: 'POST',
								headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
								body 
							})
								.then(() => {
									this.handleSuccess();
								})
								.catch(error => {
									console.error(`Error: ${error}`);
								});
						});
					}
				});
			}
			
			handleError(){
				this.cartSubtotal.classList.remove(`${this._prefix}processing`);
				if (this.discountCodes) {
					this.discountCodes.classList.remove(`${this._prefix}processing`);
				}
				this.cartDiscountError.innerHTML = window.KROWN.settings.locales.cart_discount_code_error;
			}

		}	
	)
}
// Custom add to cart js
// Custom add to cart js
document.addEventListener("DOMContentLoaded", () => {

	/* ===========================================================
	   REMOVE inerts ATTRIBUTE FROM SLIDER / RECOMMENDATIONS
	=========================================================== */
	function removeInerts() {

		document.querySelectorAll("[inerts]").forEach(el => {
			el.removeAttribute("inerts");
		});
	}

	removeInerts();

	/* ===========================================================
	   HELPER — Get Quantity from Cart Drawer
	=========================================================== */
	function getCartQtyByVariant(variantId) {

		const drawerInput = document.querySelector(
			`#AjaxCartForm input[id="updates_${variantId}"]`
		);

		return drawerInput ? parseInt(drawerInput.value) : 0;
	}

	/* ===========================================================
	   SHOW TOAST MESSAGE
	=========================================================== */
	function showCartMessage(message, type = "success") {

		const oldMsg = document.querySelector(".custom-cart-message");

		if (oldMsg) oldMsg.remove();

		const msg = document.createElement("div");

		msg.className = `custom-cart-message ${type}`;
		msg.textContent = message;

		document.body.appendChild(msg);

		setTimeout(() => {
			msg.classList.add("show");
		}, 50);

		setTimeout(() => {

			msg.classList.remove("show");

			setTimeout(() => {
				msg.remove();
			}, 500);

		}, 3000);
	}

	/* ===========================================================
	   TOGGLE UI
	=========================================================== */
	function toggleCartUI(productCard, qty) {

		if (!productCard) return;

		const addBtn = productCard.querySelector(".custom-addtocart");
		const qtyBox = productCard.querySelector(".quick-add-to-cart");

		if (qty <= 0) {

			addBtn?.style.setProperty("display", "block");
			qtyBox?.style.setProperty("display", "none");

		} else {

			addBtn?.style.setProperty("display", "none");
			qtyBox?.style.setProperty("display", "block");
		}
	}

	/* ===========================================================
	   REFRESH CART DRAWER
	=========================================================== */
	function refreshCartDrawer() {

		fetch("?section_id=helper-cart")
			.then(response => response.text())
			.then(text => {

				const html = new DOMParser()
					.parseFromString(text, "text/html");

				const cartFormInnerHTML =
					html.getElementById("AjaxCartForm").innerHTML;

				const cartSubtotalInnerHTML =
					html.getElementById("AjaxCartSubtotal").innerHTML;

				const cartItems =
					document.getElementById("AjaxCartForm");

				cartItems.innerHTML = cartFormInnerHTML;

				if (cartItems.ajaxifyCartItems) {
					cartItems.ajaxifyCartItems();
				}

				document.querySelectorAll("[data-header-cart-count]")
					.forEach(elm => {

						const countElm =
							cartItems.querySelector("[data-cart-count]");

						if (countElm) {
							elm.textContent = countElm.textContent;
						}
					});

				document.querySelectorAll("[data-header-cart-total]")
					.forEach(elm => {

						const totalElm =
							cartItems.querySelector("[data-cart-total]");

						if (totalElm) {
							elm.textContent = totalElm.textContent;
						}
					});

				document.getElementById("AjaxCartSubtotal").innerHTML =
					cartSubtotalInnerHTML;

				/* RELOAD RECOMMENDATIONS */
				if (document.querySelector("cart-recommendations")) {

					document.querySelector("cart-recommendations").innerHTML = "";

					document.querySelector("cart-recommendations")
						.generateRecommendations();

					setTimeout(() => {

						removeInerts();

						initQuickAdd(document);

					}, 1000);
				}
			});
	}

	/* ===========================================================
	   ADD TO CART
	=========================================================== */
	async function addToCart(variantId, expiryDate) {

	try {

		const cartData = {
			id: variantId,
			quantity: 1
		};

		if (expiryDate) {
			cartData.properties = {
				"Expiration Date": expiryDate
			};
		}

		const response = await fetch("/cart/add.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"Accept": "application/json"
			},
			body: JSON.stringify(cartData)
		});

		if (!response.ok) {

			const errorText = await response.text();

			console.log(errorText);

			throw new Error("Cart add failed");
		}

		const data = await response.json();

		refreshCartDrawer();

		showCartMessage("Added to cart");

		return data;

	} catch (error) {

		console.log(error);

		showCartMessage("Something went wrong", "error");
	}
}

	/* ===========================================================
	   UPDATE CART
	=========================================================== */
	function updateCart(ProductId, qty, oldQty = 0) {

		const cartForm =
			document.getElementById("AjaxCartForm");

		if (!cartForm) return;

		const item = document.querySelector(
			`#AjaxCartForm [data-js-cart-item][data-product-id="${ProductId}"]`
		);

		if (!item) return;

		cartForm.updateCartQty(item, qty);

		if (qty > oldQty) {

			showCartMessage("Added to cart");

		} else if (qty <= 0) {

			showCartMessage("Removed from cart", "remove");

		} else {

			showCartMessage("Quantity updated");
		}
	}

	/* ===========================================================
	   INIT QUICK ADD
	=========================================================== */
	function initQuickAdd(scope = document) {

		scope.querySelectorAll(
			".quick-add-to-cart-button product-quantity[data-js-product-quantity]"
		).forEach(qtyBox => {

			if (qtyBox.dataset.initialized) return;

			qtyBox.dataset.initialized = "true";

			const productCard =
				qtyBox.closest(".product-item");

			if (!productCard) return;

			const input =
				qtyBox.querySelector(".qty-selector");

			const form =
				productCard.querySelector("form");

			if (!form) return;

			const variantInput =
				form.querySelector('input[name="id"]');

			const productInput =
				form.querySelector('input[name="product-id"]');

			if (!variantInput || !productInput) return;

			const variantId = variantInput.value;
			const ProductId = productInput.value;

			/* INITIAL SYNC */
			const cartQty =
				getCartQtyByVariant(variantId);

			input.value = cartQty;

			toggleCartUI(productCard, cartQty);

			/* CART DRAWER SYNC */
			document.addEventListener(
				"cart-qty-changed",
				(e) => {

					const {
						variantId: changedVariant,
						qty
					} = e.detail;

					if (changedVariant == variantId) {

						input.value = qty;

						toggleCartUI(productCard, qty);
					}
				}
			);
		});
	}

	/* ===========================================================
	   INITIALIZE
	=========================================================== */
	initQuickAdd(document);

	/* ===========================================================
	   OBSERVE AJAX / SLIDER CONTENT
	=========================================================== */
	const observer = new MutationObserver(() => {

		removeInerts();

		initQuickAdd(document);
	});

	observer.observe(document.body, {
		childList: true,
		subtree: true
	});

	/* ===========================================================
	   ADD TO CART BUTTON CLICK
	=========================================================== */
	document.addEventListener("click", async (e) => {

		const addBtn =
			e.target.closest(".custom-addtocart");

		if (!addBtn) return;

		if (addBtn.classList.contains("adding")) return;

		addBtn.classList.add("adding");

		const productCard =
			addBtn.closest(".product-item");

		if (!productCard) return;

		const form =
			productCard.querySelector("form");

		if (!form) return;

		const variantId =
			form.querySelector('input[name="id"]')?.value;

		const ProductId =
			form.querySelector('input[name="product-id"]')?.value;

		const input =
			productCard.querySelector(".qty-selector");

		const expiryDate = addBtn.dataset.expiryDate?.trim();

		if (!variantId || !input) return;

		input.value = 1;

		//console.log(expiryDate, " ested ok"); 

		await addToCart(variantId, expiryDate);

		toggleCartUI(productCard, 1);

		setTimeout(() => {
			addBtn.classList.remove("adding");
		}, 500);
	});

	/* ===========================================================
	   PLUS CLICK
	=========================================================== */
	document.addEventListener("click", async (e) => {

		const plus =
			e.target.closest(".qty-plus");

		if (!plus) return;

		const productCard =
			plus.closest(".product-item");

		if (!productCard) return;

		const input =
			productCard.querySelector(".qty-selector");

		const form =
			productCard.querySelector("form");

		if (!input || !form) return;

		const variantId =
			form.querySelector('input[name="id"]')?.value;

		const ProductId =
			form.querySelector('input[name="product-id"]')?.value;

		if (!variantId || !ProductId) return;

		const oldQty =
			parseInt(input.value) || 0;

		setTimeout(async () => {

			const qty =
				parseInt(input.value) || 0;

			if (qty === 1 &&
				getCartQtyByVariant(variantId) === 0) {

				await addToCart(variantId);

			} else {

				updateCart(ProductId, qty, oldQty);
			}

			toggleCartUI(productCard, qty);

		}, 50);
	});

	/* ===========================================================
	   MINUS CLICK
	=========================================================== */
	document.addEventListener("click", (e) => {

		const minus =
			e.target.closest(".qty-minus");

		if (!minus) return;

		const productCard =
			minus.closest(".product-item");

		if (!productCard) return;

		const input =
			productCard.querySelector(".qty-selector");

		const form =
			productCard.querySelector("form");

		if (!input || !form) return;

		const ProductId =
			form.querySelector('input[name="product-id"]')?.value;

		if (!ProductId) return;

		const oldQty =
			parseInt(input.value) || 0;

		setTimeout(() => {

			const qty =
				parseInt(input.value) || 0;

			updateCart(ProductId, qty, oldQty);

			toggleCartUI(productCard, qty);

		}, 50);
	});

	/* ===========================================================
	   CART DRAWER +/- SYNC
	=========================================================== */
	document.addEventListener("click", (e) => {

		const qtyHolder =
			e.target.closest("cart-product-quantity");

		if (!qtyHolder) return;

		setTimeout(() => {

			const cartItem =
				qtyHolder.closest("[data-js-cart-item]");

			if (!cartItem) return;

			const variantId =
				cartItem.dataset.id.split(":")[0];

			const qty =
				parseInt(
					cartItem.querySelector(".qty").value
				);

			document.dispatchEvent(
				new CustomEvent("cart-qty-changed", {
					detail: {
						variantId,
						qty
					}
				})
			);

		}, 100);
	});

});

